import { c as POPOVER_MOTION_PROPS, n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { _ as useTheme_v2, i as usePrefersReducedMotion, n as LayerProvider, o as useMediaIndex, s as Card, t as useLayer } from "./useLayer-BAVfmbNN.js";
import { t as Flex } from "./flex-C-5JHi1C.js";
import { t as useElementSize } from "./useElementSize-BJvbGHq8.js";
import { n as AnimateActivity, r as origin, t as getElementRef } from "./getElementRef-5HZQ-Owu.js";
import { a as useBoundaryElement, n as Portal, t as Arrow } from "./arrow-CHE8-_G7.js";
import { c } from "react/compiler-runtime";
import { Activity, cloneElement, useEffect, useImperativeHandle, useRef, useState } from "react";
import { styled } from "styled-components";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { arrow, autoPlacement, autoUpdate, detectOverflow, flip, hide, offset, shift, useFloating } from "@floating-ui/react-dom";
import { motion } from "motion/react";
const DEFAULT_POPOVER_MARGINS = [
	0,
	0,
	0,
	0
], DEFAULT_FALLBACK_PLACEMENTS = {
	top: [
		"bottom",
		"left",
		"right"
	],
	"top-start": [
		"bottom-start",
		"left-start",
		"right-start"
	],
	"top-end": [
		"bottom-end",
		"left-end",
		"right-end"
	],
	bottom: [
		"top",
		"left",
		"right"
	],
	"bottom-start": [
		"top-start",
		"left-start",
		"right-start"
	],
	"bottom-end": [
		"top-end",
		"left-end",
		"right-end"
	],
	left: [
		"right",
		"top",
		"bottom"
	],
	"left-start": [
		"right-start",
		"top-start",
		"bottom-start"
	],
	"left-end": [
		"right-end",
		"top-end",
		"bottom-end"
	],
	right: [
		"left",
		"top",
		"bottom"
	],
	"right-start": [
		"left-start",
		"top-start",
		"bottom-start"
	],
	"right-end": [
		"left-end",
		"top-end",
		"bottom-end"
	]
};
function size(options) {
	let { constrainSize, margins, matchReferenceWidth, maxWidthRef, padding = 0, referenceWidthRef, setReferenceWidth, widthRef } = options;
	return {
		name: "@sanity/ui/size",
		async fn(args) {
			let { elements, placement, platform, rects } = args, { floating, reference } = rects, overflow = await detectOverflow(args, {
				altBoundary: !0,
				boundary: options.boundaryElement || void 0,
				elementContext: "floating",
				padding,
				rootBoundary: "viewport"
			}), maxWidth = Infinity, maxHeight = Infinity, floatingW = floating.width, floatingH = floating.height;
			placement.includes("top") && (maxWidth = floatingW - (overflow.left + overflow.right), maxHeight = floatingH - overflow.top), placement.includes("right") && (maxWidth = floatingW - overflow.right, maxHeight = floatingH - (overflow.top + overflow.bottom)), placement.includes("bottom") && (maxWidth = floatingW - (overflow.left + overflow.right), maxHeight = floatingH - overflow.bottom), placement.includes("left") && (maxWidth = floatingW - overflow.left, maxHeight = floatingH - (overflow.top + overflow.bottom));
			let availableWidth = maxWidth - margins[1] - margins[3], availableHeight = maxHeight - margins[0] - margins[2], referenceWidth = reference.width - margins[1] - margins[3];
			referenceWidthRef.current = referenceWidth, setReferenceWidth(referenceWidth), matchReferenceWidth ? elements.floating.style.width = `${referenceWidth}px` : widthRef.current !== void 0 && (elements.floating.style.width = `${widthRef.current}px`), constrainSize && (elements.floating.style.maxWidth = `${Math.min(availableWidth, maxWidthRef.current ?? Infinity)}px`, elements.floating.style.maxHeight = `${availableHeight}px`);
			let nextDimensions = await platform.getDimensions(elements.floating), targetH = nextDimensions.height;
			return floatingW !== nextDimensions.width || floatingH !== targetH ? { reset: { rects: !0 } } : {};
		}
	};
}
function calcCurrentWidth(params) {
	let { container, mediaIndex, width } = params, w = width[mediaIndex], currentWidth = w === void 0 ? width[width.length - 1] : w;
	return typeof currentWidth == "number" ? container[currentWidth] : void 0;
}
function calcMaxWidth(params) {
	let { boundaryWidth, currentWidth } = params;
	if (currentWidth !== void 0 || boundaryWidth !== void 0) return Math.min(currentWidth ?? Infinity, (boundaryWidth || Infinity) - 8);
}
const MotionCard = styled(motion.create(Card)).withConfig({
	displayName: "MotionCard",
	componentId: "sc-9hcc5m-0"
})`&:not([hidden]){display:flex;}flex-direction:column;width:max-content;min-width:min-content;will-change:transform;`, MotionFlex = styled(motion.create(Flex)).withConfig({
	displayName: "MotionFlex",
	componentId: "sc-9hcc5m-1"
})`will-change:opacity;`;
/**
* @internal
*/
function PopoverCard(props) {
	let $ = c(67), animate, arrow, arrowRef, arrowX, arrowY, children, marginsProp, originX, originY, overflow, padding, placement, radius, ref, restProps, scheme, shadow, strategy, style, tone, width, xProp, yProp;
	$[0] === props ? (animate = $[1], arrow = $[2], arrowRef = $[3], arrowX = $[4], arrowY = $[5], children = $[6], marginsProp = $[7], originX = $[8], originY = $[9], overflow = $[10], padding = $[11], placement = $[12], radius = $[13], ref = $[14], restProps = $[15], scheme = $[16], shadow = $[17], strategy = $[18], style = $[19], tone = $[20], width = $[21], xProp = $[22], yProp = $[23]) : ({__unstable_margins: marginsProp, animate, arrow, arrowRef, arrowX, arrowY, children, padding, placement, originX, originY, overflow, radius, ref, scheme, shadow, strategy, style, tone, width, x: xProp, y: yProp, ...restProps} = props, $[0] = props, $[1] = animate, $[2] = arrow, $[3] = arrowRef, $[4] = arrowX, $[5] = arrowY, $[6] = children, $[7] = marginsProp, $[8] = originX, $[9] = originY, $[10] = overflow, $[11] = padding, $[12] = placement, $[13] = radius, $[14] = ref, $[15] = restProps, $[16] = scheme, $[17] = shadow, $[18] = strategy, $[19] = style, $[20] = tone, $[21] = width, $[22] = xProp, $[23] = yProp);
	let { zIndex } = useLayer(), margins = marginsProp || DEFAULT_POPOVER_MARGINS, x = (xProp ?? 0) + margins[3], y = (yProp ?? 0) + margins[0], t0 = animate ? "transform" : void 0, t1;
	$[24] !== originX || $[25] !== originY || $[26] !== strategy || $[27] !== style || $[28] !== t0 || $[29] !== width || $[30] !== x || $[31] !== y || $[32] !== zIndex ? (t1 = {
		left: x,
		originX,
		originY,
		position: strategy,
		top: y,
		width,
		zIndex,
		willChange: t0,
		...style
	}, $[24] = originX, $[25] = originY, $[26] = strategy, $[27] = style, $[28] = t0, $[29] = width, $[30] = x, $[31] = y, $[32] = zIndex, $[33] = t1) : t1 = $[33];
	let rootStyle = t1, t2 = arrowX === null ? void 0 : arrowX, t3 = arrowY === null ? void 0 : arrowY, t4;
	$[34] !== t2 || $[35] !== t3 ? (t4 = {
		left: t2,
		top: t3,
		right: void 0,
		bottom: void 0
	}, $[34] = t2, $[35] = t3, $[36] = t4) : t4 = $[36];
	let arrowStyle = t4, t5;
	$[37] === animate ? t5 = $[38] : (t5 = animate ? ["hidden", "initial"] : void 0, $[37] = animate, $[38] = t5);
	let t6;
	$[39] === animate ? t6 = $[40] : (t6 = animate ? ["visible", "scaleIn"] : void 0, $[39] = animate, $[40] = t6);
	let t7;
	$[41] === animate ? t7 = $[42] : (t7 = animate ? ["hidden", "scaleOut"] : void 0, $[41] = animate, $[42] = t7);
	let t8;
	$[43] !== children || $[44] !== padding ? (t8 = /* @__PURE__ */ jsx(Flex, {
		direction: "column",
		flex: 1,
		padding,
		children
	}), $[43] = children, $[44] = padding, $[45] = t8) : t8 = $[45];
	let t9;
	$[46] !== overflow || $[47] !== t8 ? (t9 = /* @__PURE__ */ jsx(MotionFlex, {
		"data-ui": "Popover__wrapper",
		direction: "column",
		flex: 1,
		overflow,
		variants: POPOVER_MOTION_PROPS.children,
		transition: POPOVER_MOTION_PROPS.transition,
		children: t8
	}), $[46] = overflow, $[47] = t8, $[48] = t9) : t9 = $[48];
	let t10;
	$[49] !== arrow || $[50] !== arrowRef || $[51] !== arrowStyle ? (t10 = arrow && /* @__PURE__ */ jsx(Arrow, {
		ref: arrowRef,
		style: arrowStyle,
		width: 19,
		height: 8,
		radius: 2
	}), $[49] = arrow, $[50] = arrowRef, $[51] = arrowStyle, $[52] = t10) : t10 = $[52];
	let t11;
	return $[53] !== placement || $[54] !== radius || $[55] !== ref || $[56] !== restProps || $[57] !== rootStyle || $[58] !== scheme || $[59] !== shadow || $[60] !== t10 || $[61] !== t5 || $[62] !== t6 || $[63] !== t7 || $[64] !== t9 || $[65] !== tone ? (t11 = /* @__PURE__ */ jsxs(MotionCard, {
		"data-ui": "Popover",
		...restProps,
		"data-placement": placement,
		radius,
		ref,
		scheme,
		shadow,
		sizing: "border",
		style: rootStyle,
		tone,
		variants: POPOVER_MOTION_PROPS.card,
		transition: POPOVER_MOTION_PROPS.transition,
		initial: t5,
		animate: t6,
		exit: t7,
		children: [t9, t10]
	}), $[53] = placement, $[54] = radius, $[55] = ref, $[56] = restProps, $[57] = rootStyle, $[58] = scheme, $[59] = shadow, $[60] = t10, $[61] = t5, $[62] = t6, $[63] = t7, $[64] = t9, $[65] = tone, $[66] = t11) : t11 = $[66], t11;
}
const ViewportOverlay = () => {
	let $ = c(2), { zIndex } = useLayer(), t0;
	return $[0] === zIndex ? t0 = $[1] : (t0 = /* @__PURE__ */ jsx("div", { style: {
		height: "100vh",
		inset: 0,
		position: "fixed",
		width: "100vw",
		zIndex
	} }), $[0] = zIndex, $[1] = t0), t0;
};
/**
* The `Popover` component is used to display some content on top of another.
*
* @public
*/
function Popover(props) {
	let $ = c(126), { container, layer } = useTheme_v2(), boundaryElementContext = useBoundaryElement(), _fallbackPlacements, _floatingBoundary, _referenceBoundary, _zOffsetProp, childProp, content, disabled, forwardedRef, matchReferenceWidth, modal, open, paddingProp, portal, referenceElement, restProps, scheme, t0, t1, t10, t11, t2, t3, t4, t5, t6, t7, t8, t9, updateRef;
	if ($[0] !== props) {
		let { __unstable_margins: t12, animate: t13, arrow: t14, children: t15, constrainSize: t16, content: t17, disabled: t18, fallbackPlacements: t19, matchReferenceWidth: t20, floatingBoundary: t21, modal: t22, onActivate, open: t23, overflow: t24, padding: t25, placement: t26, placementStrategy: t27, portal: t28, preventOverflow: t29, radius: t30, ref: t31, referenceBoundary: t32, referenceElement: t33, scheme: t34, shadow: t35, tone: t36, width: t37, zOffset: t38, updateRef: t39, ...t40 } = props;
		t0 = t12, t1 = t13, t2 = t14, childProp = t15, t3 = t16, content = t17, disabled = t18, _fallbackPlacements = t19, matchReferenceWidth = t20, _floatingBoundary = t21, modal = t22, open = t23, t4 = t24, paddingProp = t25, t5 = t26, t6 = t27, portal = t28, t7 = t29, t8 = t30, forwardedRef = t31, _referenceBoundary = t32, referenceElement = t33, scheme = t34, t9 = t35, t10 = t36, t11 = t37, _zOffsetProp = t38, updateRef = t39, restProps = t40, $[0] = props, $[1] = _fallbackPlacements, $[2] = _floatingBoundary, $[3] = _referenceBoundary, $[4] = _zOffsetProp, $[5] = childProp, $[6] = content, $[7] = disabled, $[8] = forwardedRef, $[9] = matchReferenceWidth, $[10] = modal, $[11] = open, $[12] = paddingProp, $[13] = portal, $[14] = referenceElement, $[15] = restProps, $[16] = scheme, $[17] = t0, $[18] = t1, $[19] = t10, $[20] = t11, $[21] = t2, $[22] = t3, $[23] = t4, $[24] = t5, $[25] = t6, $[26] = t7, $[27] = t8, $[28] = t9, $[29] = updateRef;
	} else _fallbackPlacements = $[1], _floatingBoundary = $[2], _referenceBoundary = $[3], _zOffsetProp = $[4], childProp = $[5], content = $[6], disabled = $[7], forwardedRef = $[8], matchReferenceWidth = $[9], modal = $[10], open = $[11], paddingProp = $[12], portal = $[13], referenceElement = $[14], restProps = $[15], scheme = $[16], t0 = $[17], t1 = $[18], t10 = $[19], t11 = $[20], t2 = $[21], t3 = $[22], t4 = $[23], t5 = $[24], t6 = $[25], t7 = $[26], t8 = $[27], t9 = $[28], updateRef = $[29];
	let margins = t0 === void 0 ? DEFAULT_POPOVER_MARGINS : t0, _animate = t1 !== void 0 && t1, arrowProp = t2 !== void 0 && t2, constrainSize = t3 !== void 0 && t3, overflow = t4 === void 0 ? "hidden" : t4, placementProp = t5 === void 0 ? "bottom" : t5, placementStrategy = t6 === void 0 ? "flip" : t6, preventOverflow = t7 === void 0 || t7, radiusProp = t8 === void 0 ? 3 : t8, shadowProp = t9 === void 0 ? 3 : t9, tone = t10 === void 0 ? "inherit" : t10, widthProp = t11 === void 0 ? "auto" : t11, fallbackPlacements = _fallbackPlacements ?? DEFAULT_FALLBACK_PLACEMENTS[props.placement ?? "bottom"], floatingBoundary = _floatingBoundary ?? boundaryElementContext.element, referenceBoundary = _referenceBoundary ?? boundaryElementContext.element, boundaryElement = boundaryElementContext.element ?? floatingBoundary, zOffsetProp = _zOffsetProp ?? layer.popover.zOffset, animate = !usePrefersReducedMotion() && _animate, boundarySize = useElementSize(boundaryElement)?.border, t12;
	$[30] === paddingProp ? t12 = $[31] : (t12 = _getArrayProp(paddingProp), $[30] = paddingProp, $[31] = t12);
	let padding = t12, t13;
	$[32] === radiusProp ? t13 = $[33] : (t13 = _getArrayProp(radiusProp), $[32] = radiusProp, $[33] = t13);
	let radius = t13, t14;
	$[34] === shadowProp ? t14 = $[35] : (t14 = _getArrayProp(shadowProp), $[34] = shadowProp, $[35] = t14);
	let shadow = t14, widthArrayProp = _getArrayProp(widthProp), t15;
	$[36] === zOffsetProp ? t15 = $[37] : (t15 = _getArrayProp(zOffsetProp), $[36] = zOffsetProp, $[37] = t15);
	let zOffset = t15, ref = useRef(null), arrowRef = useRef(null), t16;
	$[38] === Symbol.for("react.memo_cache_sentinel") ? (t16 = () => ref.current, $[38] = t16) : t16 = $[38], useImperativeHandle(forwardedRef, t16);
	let mediaIndex = useMediaIndex(), boundaryWidth = constrainSize || preventOverflow ? boundarySize?.width : void 0, width = calcCurrentWidth({
		container,
		mediaIndex,
		width: widthArrayProp
	}), widthRef = useRef(width), t17, t18;
	$[39] === width ? (t17 = $[40], t18 = $[41]) : (t17 = () => {
		widthRef.current = width;
	}, t18 = [width], $[39] = width, $[40] = t17, $[41] = t18), useEffect(t17, t18);
	let t19;
	$[42] !== boundaryWidth || $[43] !== width ? (t19 = calcMaxWidth({
		boundaryWidth,
		currentWidth: width
	}), $[42] = boundaryWidth, $[43] = width, $[44] = t19) : t19 = $[44];
	let maxWidth = t19, maxWidthRef = useRef(maxWidth), t20, t21;
	$[45] === maxWidth ? (t20 = $[46], t21 = $[47]) : (t20 = () => {
		maxWidthRef.current = maxWidth;
	}, t21 = [maxWidth], $[45] = maxWidth, $[46] = t20, $[47] = t21), useEffect(t20, t21);
	let referenceWidthRef = useRef(void 0), t22, t23;
	$[48] !== matchReferenceWidth || $[49] !== maxWidth || $[50] !== open || $[51] !== width ? (t22 = () => {
		let floatingElement = ref.current;
		if (!open || !floatingElement) return;
		let referenceWidth = referenceWidthRef.current;
		matchReferenceWidth ? referenceWidth !== void 0 && (floatingElement.style.width = `${referenceWidth}px`) : width !== void 0 && (floatingElement.style.width = `${width}px`), typeof maxWidth == "number" && (floatingElement.style.maxWidth = `${maxWidth}px`);
	}, t23 = [
		width,
		matchReferenceWidth,
		maxWidth,
		open
	], $[48] = matchReferenceWidth, $[49] = maxWidth, $[50] = open, $[51] = width, $[52] = t22, $[53] = t23) : (t22 = $[52], t23 = $[53]), useEffect(t22, t23);
	let [referenceWidth_0, setReferenceWidth] = useState(void 0), t24;
	$[54] !== animate || $[55] !== arrowProp || $[56] !== constrainSize || $[57] !== fallbackPlacements || $[58] !== floatingBoundary || $[59] !== margins || $[60] !== matchReferenceWidth || $[61] !== placementProp || $[62] !== placementStrategy || $[63] !== preventOverflow || $[64] !== referenceBoundary ? (t24 = {
		animate,
		arrowProp,
		arrowRef,
		constrainSize,
		fallbackPlacements,
		floatingBoundary,
		margins,
		matchReferenceWidth,
		maxWidthRef,
		placementProp,
		placementStrategy,
		preventOverflow,
		referenceBoundary,
		referenceWidthRef,
		rootBoundary: "viewport",
		setReferenceWidth,
		widthRef
	}, $[54] = animate, $[55] = arrowProp, $[56] = constrainSize, $[57] = fallbackPlacements, $[58] = floatingBoundary, $[59] = margins, $[60] = matchReferenceWidth, $[61] = placementProp, $[62] = placementStrategy, $[63] = preventOverflow, $[64] = referenceBoundary, $[65] = t24) : t24 = $[65];
	let middleware = useMiddleware(t24), t25;
	$[66] === referenceElement ? t25 = $[67] : (t25 = referenceElement ? { reference: referenceElement } : void 0, $[66] = referenceElement, $[67] = t25);
	let t26;
	$[68] !== middleware || $[69] !== placementProp || $[70] !== t25 ? (t26 = {
		middleware,
		placement: placementProp,
		whileElementsMounted: autoUpdate,
		elements: t25
	}, $[68] = middleware, $[69] = placementProp, $[70] = t25, $[71] = t26) : t26 = $[71];
	let { x, y, middlewareData, placement, refs, strategy, update } = useFloating(t26), referenceHidden = middlewareData.hide?.referenceHidden, arrowX = middlewareData.arrow?.x, arrowY = middlewareData.arrow?.y, originX = middlewareData["@sanity/ui/origin"]?.originX, originY = middlewareData["@sanity/ui/origin"]?.originY, t27;
	$[72] === Symbol.for("react.memo_cache_sentinel") ? (t27 = (arrowEl) => {
		arrowRef.current = arrowEl;
	}, $[72] = t27) : t27 = $[72];
	let setArrow = t27, t28;
	$[73] === refs ? t28 = $[74] : (t28 = (node) => {
		ref.current = node, refs.setFloating(node);
	}, $[73] = refs, $[74] = t28);
	let setFloating = t28, t29;
	$[75] === childProp ? t29 = $[76] : (t29 = childProp ? getElementRef(childProp) : null, $[75] = childProp, $[76] = t29);
	let t30;
	$[77] === refs.reference.current ? t30 = $[78] : (t30 = () => refs.reference.current, $[77] = refs.reference.current, $[78] = t30), useImperativeHandle(t29, t30);
	let t31;
	bb0: {
		if (referenceElement) {
			t31 = childProp;
			break bb0;
		}
		if (!childProp) {
			t31 = null;
			break bb0;
		}
		let t32;
		$[79] !== childProp || $[80] !== refs.setReference ? (t32 = cloneElement(childProp, { ref: refs.setReference }), $[79] = childProp, $[80] = refs.setReference, $[81] = t32) : t32 = $[81], t31 = t32;
	}
	let child = t31, t32, t33;
	if ($[82] === update ? (t32 = $[83], t33 = $[84]) : (t32 = () => update, t33 = [update], $[82] = update, $[83] = t32, $[84] = t33), useImperativeHandle(updateRef, t32, t33), disabled) {
		let t34;
		return $[85] === childProp ? t34 = $[86] : (t34 = childProp || /* @__PURE__ */ jsx(Fragment$1, {}), $[85] = childProp, $[86] = t34), t34;
	}
	let t34;
	$[87] === modal ? t34 = $[88] : (t34 = modal && /* @__PURE__ */ jsx(ViewportOverlay, {}), $[87] = modal, $[88] = t34);
	let t35 = matchReferenceWidth ? referenceWidth_0 : width, t36;
	$[89] !== animate || $[90] !== arrowProp || $[91] !== arrowX || $[92] !== arrowY || $[93] !== content || $[94] !== margins || $[95] !== originX || $[96] !== originY || $[97] !== overflow || $[98] !== padding || $[99] !== placement || $[100] !== radius || $[101] !== referenceHidden || $[102] !== restProps || $[103] !== scheme || $[104] !== setFloating || $[105] !== shadow || $[106] !== strategy || $[107] !== t35 || $[108] !== tone || $[109] !== x || $[110] !== y ? (t36 = /* @__PURE__ */ jsx(PopoverCard, {
		...restProps,
		__unstable_margins: margins,
		animate,
		arrow: arrowProp,
		arrowRef: setArrow,
		arrowX,
		arrowY,
		hidden: referenceHidden,
		overflow,
		padding,
		placement,
		radius,
		ref: setFloating,
		scheme,
		shadow,
		originX,
		originY,
		strategy,
		tone,
		width: t35,
		x,
		y,
		children: content
	}), $[89] = animate, $[90] = arrowProp, $[91] = arrowX, $[92] = arrowY, $[93] = content, $[94] = margins, $[95] = originX, $[96] = originY, $[97] = overflow, $[98] = padding, $[99] = placement, $[100] = radius, $[101] = referenceHidden, $[102] = restProps, $[103] = scheme, $[104] = setFloating, $[105] = shadow, $[106] = strategy, $[107] = t35, $[108] = tone, $[109] = x, $[110] = y, $[111] = t36) : t36 = $[111];
	let t37;
	$[112] !== t34 || $[113] !== t36 || $[114] !== zOffset ? (t37 = /* @__PURE__ */ jsxs(LayerProvider, {
		zOffset,
		children: [t34, t36]
	}), $[112] = t34, $[113] = t36, $[114] = zOffset, $[115] = t37) : t37 = $[115];
	let popover = t37, t38;
	$[116] !== popover || $[117] !== portal ? (t38 = portal ? /* @__PURE__ */ jsx(Portal, {
		__unstable_name: typeof portal == "string" ? portal : void 0,
		children: popover
	}) : popover, $[116] = popover, $[117] = portal, $[118] = t38) : t38 = $[118];
	let popoverNode = t38, t39;
	$[119] !== animate || $[120] !== open || $[121] !== popoverNode ? (t39 = animate ? /* @__PURE__ */ jsx(AnimateActivity, {
		layoutMode: "default",
		mode: open ? "visible" : "hidden",
		children: popoverNode
	}) : /* @__PURE__ */ jsx(Activity, {
		mode: open ? "visible" : "hidden",
		children: popoverNode
	}), $[119] = animate, $[120] = open, $[121] = popoverNode, $[122] = t39) : t39 = $[122];
	let t40;
	return $[123] !== child || $[124] !== t39 ? (t40 = /* @__PURE__ */ jsxs(Fragment$1, { children: [t39, child] }), $[123] = child, $[124] = t39, $[125] = t40) : t40 = $[125], t40;
}
function useMiddleware(t0) {
	let $ = c(42), { animate, arrowProp, arrowRef, constrainSize, fallbackPlacements, floatingBoundary, margins, matchReferenceWidth, maxWidthRef, placementProp, placementStrategy, preventOverflow, referenceBoundary, referenceWidthRef, rootBoundary, setReferenceWidth, widthRef } = t0, ret;
	if ($[0] !== animate || $[1] !== arrowProp || $[2] !== arrowRef || $[3] !== constrainSize || $[4] !== fallbackPlacements || $[5] !== floatingBoundary || $[6] !== margins || $[7] !== matchReferenceWidth || $[8] !== maxWidthRef || $[9] !== placementProp || $[10] !== placementStrategy || $[11] !== preventOverflow || $[12] !== referenceBoundary || $[13] !== referenceWidthRef || $[14] !== rootBoundary || $[15] !== setReferenceWidth || $[16] !== widthRef) {
		if (ret = [], constrainSize || preventOverflow) {
			if (placementStrategy === "autoPlacement") {
				let t1;
				$[18] !== fallbackPlacements || $[19] !== placementProp ? (t1 = autoPlacement({ allowedPlacements: [placementProp].concat(fallbackPlacements) }), $[18] = fallbackPlacements, $[19] = placementProp, $[20] = t1) : t1 = $[20], ret.push(t1);
			} else {
				let t1 = floatingBoundary || void 0, t2;
				$[21] !== fallbackPlacements || $[22] !== rootBoundary || $[23] !== t1 ? (t2 = flip({
					boundary: t1,
					fallbackPlacements,
					padding: 4,
					rootBoundary
				}), $[21] = fallbackPlacements, $[22] = rootBoundary, $[23] = t1, $[24] = t2) : t2 = $[24], ret.push(t2);
			}
		}
		let t1;
		if ($[25] === Symbol.for("react.memo_cache_sentinel") ? (t1 = offset({ mainAxis: 4 }), $[25] = t1) : t1 = $[25], ret.push(t1), constrainSize || matchReferenceWidth) {
			let t2 = floatingBoundary || void 0, t3;
			$[26] !== constrainSize || $[27] !== margins || $[28] !== matchReferenceWidth || $[29] !== maxWidthRef || $[30] !== referenceWidthRef || $[31] !== setReferenceWidth || $[32] !== t2 || $[33] !== widthRef ? (t3 = size({
				boundaryElement: t2,
				constrainSize,
				margins,
				matchReferenceWidth,
				maxWidthRef,
				padding: 4,
				referenceWidthRef,
				setReferenceWidth,
				widthRef
			}), $[26] = constrainSize, $[27] = margins, $[28] = matchReferenceWidth, $[29] = maxWidthRef, $[30] = referenceWidthRef, $[31] = setReferenceWidth, $[32] = t2, $[33] = widthRef, $[34] = t3) : t3 = $[34], ret.push(t3);
		}
		if (preventOverflow) {
			let t2 = floatingBoundary || void 0, t3;
			$[35] !== rootBoundary || $[36] !== t2 ? (t3 = shift({
				boundary: t2,
				rootBoundary,
				padding: 4
			}), $[35] = rootBoundary, $[36] = t2, $[37] = t3) : t3 = $[37], ret.push(t3);
		}
		if (arrowProp) {
			let t2;
			$[38] === arrowRef ? t2 = $[39] : (t2 = arrow({
				element: arrowRef,
				padding: 4
			}), $[38] = arrowRef, $[39] = t2), ret.push(t2);
		}
		animate && ret.push(origin);
		let t2 = referenceBoundary || void 0, t3;
		$[40] === t2 ? t3 = $[41] : (t3 = hide({
			boundary: t2,
			padding: 4,
			strategy: "referenceHidden"
		}), $[40] = t2, $[41] = t3), ret.push(t3), $[0] = animate, $[1] = arrowProp, $[2] = arrowRef, $[3] = constrainSize, $[4] = fallbackPlacements, $[5] = floatingBoundary, $[6] = margins, $[7] = matchReferenceWidth, $[8] = maxWidthRef, $[9] = placementProp, $[10] = placementStrategy, $[11] = preventOverflow, $[12] = referenceBoundary, $[13] = referenceWidthRef, $[14] = rootBoundary, $[15] = setReferenceWidth, $[16] = widthRef, $[17] = ret;
	} else ret = $[17];
	return ret;
}
export { Popover as t };

//# sourceMappingURL=popover-PorX5Jv9.js.map